import React from "react";
import { useState } from "@wordpress/element";
import { Dashicon } from '@wordpress/components';

import sistemPisos from '../../../../assets/sistem.json'

const SistemaPisos = ({ posts, typeCalc }) => {

    const classNameSpace = 'c-pisos';
    const simpleContent = 'c-simple-cal';

    const [productList, setProductList] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const [showCalc, setShowCalc] = useState('has-show-form');
    const [sistemSelected, setsistemSelected] = useState([]);

    const [area, setArea] = useState('');
    const [showResult, setShowResult] = useState('');

    let option = [];
    let option2 = [];

    const filterProduct = (e) => {

        const sistemProducts = posts.filter(sitems => {
            const accestoSistem = sitems.block_data[0].attrs?.nameSistemas
            if (accestoSistem) {
                const names = accestoSistem.map(label => label?.label)
                return names.includes(e.target.value);
            } else {
                return;
            }
        })


        setProductList(sistemProducts);
    }

    const showResults = () => {
        setShowResult('has-show-results');
        setShowCalc('');
    }

    const backForInfo = () => {
        setShowResult('');
        setShowCalc('has-show-form');
    }

    return (
        <section className={classNameSpace + '__content'}>
            <div className={classNameSpace + '__select-product'}>
                <div className={classNameSpace + '__step-one'}>
                    <div className={classNameSpace + '__title-calc'}>
                        <h2 className={classNameSpace + '__title'}>
                            <strong className='number-step'>2</strong>
                            Selecciona un producto o un sistema para <br /> protección de pisos
                        </h2>
                    </div>

                    <div className={classNameSpace + '__product-selec'}>

                        <select className={classNameSpace + '__selector'}

                            value={selectedOption.label}
                            onChange={(e) => {
                                e.target.value != 0 ? filterProduct(e) : '';
                                setsistemSelected(e.target.value);
                            }
                            }

                        >
                            <option value='0'>Seleccionar un sistema</option>
                            {sistemPisos.map((option) => (
                                <option key={option.id} value={option.label}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
                {productList &&
                    <div className={classNameSpace + '__options c-pisos__step-one'}>



                        {productList.map((product, index) => {

                            const options = product.block_data[0].attrs.datosSistemasPisos.dataSystem;
                            const hasSecondOptions = options.some(obj => obj.option === "opcion_2");

                            if (hasSecondOptions == false) {
                                option.push(product);
                            }

                            if (hasSecondOptions == true) {
                                option2.push(product)
                            }

                        })
                        }

                        <div className={classNameSpace + '__option-one ' + classNameSpace + '__options-products'}>
                            <h3 className={classNameSpace + '__option-title'}>Opción 1</h3>
                            <div className={classNameSpace + '__producto-content'}>
                                {option.map(product => {
                                    return (
                                        <div className={classNameSpace + '__product-elements'}>
                                            <h4 className={classNameSpace + '__product-title'}>{product.title}</h4>
                                            <img className={classNameSpace + '__product-imagen'} src={product.featured_thumbnail} />
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>

                        <div className={classNameSpace + '__option-two ' + classNameSpace + '__options-products'}>
                            {option2.length ? <h3 className={classNameSpace + '__option-title'}>Opción 2</h3> : null}
                            <div className={classNameSpace + '__producto-content'}>
                                {option2.map(product => {
                                    return (
                                        <div className={classNameSpace + '__product-elements'}>
                                            <h4 className={classNameSpace + '__product-title'}>{product.title}</h4>
                                            <img className={classNameSpace + '__product-imagen'} src={product.featured_thumbnail} />
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>

                    </div>
                }

            </div>
            {productList &&
                <div className={simpleContent + '__select-dimenction'}>
                    <div className={simpleContent + '__step-two ' + showCalc}>

                        <h3 className={simpleContent + '__title'}>
                            <strong className='number-step'>3</strong>
                            Dimensiones y  medidas
                        </h3>
                        <div className={simpleContent + '__area-input'}>

                            <input
                                className={simpleContent + '__element'}
                                placeholder="Área"
                                type="number"
                                value={area}
                                onChange={event => setArea(event.target.value)}
                            />
                        </div>

                        <small className={simpleContent + '__help'}>
                            * Debes poner el área total en M² <br></br>
                            * El campo permite agregar puntos y comas
                        </small>
                        {area &&
                            <div className={simpleContent + '__btn-calcular'}
                                onClick={showResults}>
                                <p className={simpleContent + '__calcular-text'}>Calcular <Dashicon icon="arrow-right-alt" /></p>
                            </div>
                        }
                    </div>

                    <div className={simpleContent + '__result ' + showResult}>
                        {area &&
                            <>
                                <div className={simpleContent + '__content-cal'}>

                                    <div className={simpleContent + '__content-options'}>
                                        <div className={simpleContent + '__result-one'}>
                                            <h3 className={classNameSpace + '__option-title'}>Opción 1</h3>
                                            {
                                                option.map(product => {
                                                    const dataSistemSelected = product.block_data[0].attrs.datosSistemasPisos.dataSystem.filter(options => {
                                                        return options.name == sistemSelected
                                                    });

                                                    return (
                                                        <>
                                                            <h4 className={classNameSpace + '__desc-title'}>Cantidad producto: {product.title}</h4>
                                                            <h4 className={classNameSpace + '__title-product'}>
                                                                {
                                                                    `${Math.round(area / parseInt(dataSistemSelected[0].varlo_rendimiento))} 
                                                                ${dataSistemSelected[0].presentation_1}`
                                                                }
                                                            </h4>
                                                            <p className={classNameSpace + '__manos'}>{dataSistemSelected[0].rend_manos}</p>
                                                        </>
                                                    )

                                                })}

                                        </div>
                                        <div className={simpleContent + '__result-two'}>
                                            {option2.length ? <h3 className={classNameSpace + '__option-title'}>Opción 2</h3> : null}
                                            {option2?.map(product => {
                                                const dataSistemSelected = product.block_data[0].attrs.datosSistemasPisos.dataSystem.filter(options => {
                                                    return options.name == sistemSelected
                                                });

                                                return (
                                                    <>
                                                        <h4 className={classNameSpace + '__desc-title'}>Cantidad producto: {product.title}</h4>
                                                        <h4 className={classNameSpace + '__title-product'}>
                                                            {
                                                                `${Math.round(area / parseInt(dataSistemSelected[0].varlo_rendimiento))} 
                                                                ${dataSistemSelected[0].presentation_1}`
                                                            }
                                                        </h4>
                                                        <p className={classNameSpace + '__manos'}>{dataSistemSelected[0].rend_manos}</p>
                                                    </>
                                                )

                                            })}
                                        </div>
                                    </div>
                                    <p className={simpleContent + '__note-area'}>Área: {area}</p>
                                    <p className={simpleContent + '__note-perfomance'}>
                                        Rendimiento práctico estimado con un 10% de perdida estimada (aplicación brocha o rodillo), si se va a realizar aplicación con pistola disminuye el rendimiento por mayor perdida.
                                    </p>
                                </div>
                                <p className={simpleContent + '__back-calculate'}
                                    onClick={backForInfo}
                                ><Dashicon icon="arrow-left-alt" />Volver a Calcular</p>
                            </>
                        }
                    </div>
                </div>
            }
        </section>

    )
}

export default SistemaPisos;